module.exports = __webpack_public_path__ + "img/home_fr10.edec8413.png";